<template>
  <div>
    <gmap-map :center="center" :zoom="10" class="map-container">
      <gmap-marker
        :key="index"
        v-for="(m, index) in datamarker"
        :position="m.position"
        @click="center = m.position"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: 'GoogleMap',
  props: {
    getmarkers: Array,
    default: [],
  },
  data() {
    return {
      center: { lat: 13.736717, lng: 100.523186 },
      markers: [],
      places: [],
      currentPlace: null,
    }
  },
  mounted() {
    this.geolocate()
  },
  computed: {
    datamarker() {
      return this.getmarkers ? this.getmarkers : []
    },
  },
  methods: {
    setPlace(place) {
      this.currentPlace = place
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        }
        this.markers.push({
          position: marker,
          icon: 'http://lorempixel.com/800/600/nature/',
        })
        this.places.push(this.currentPlace)
        this.center = marker
        this.currentPlace = null
      }
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }
      })

      this.markers = this.getmarkers
    },
  },
}
</script>
<style scoped lang="scss">
.map-container {
  width: 100%;
  min-height: 500px;
}
</style>
